import { useState, useEffect, useRef, useCallback } from 'react';
const useResizable = (isActive, options) => {
    const [height, setHeight] = useState(0);
    const contentRef = useRef(null);
    const resizeObserverRef = useRef(null);
    const updateHeight = useCallback(() => {
        if (contentRef.current) {
            const newHeight = contentRef.current.scrollHeight;
            setHeight(newHeight);
            options?.onResize?.(newHeight);
        }
    }, [options]);
    useEffect(() => {
        if (contentRef.current && isActive) {
            updateHeight();
            resizeObserverRef.current = new ResizeObserver(() => {
                updateHeight();
            });
            resizeObserverRef.current.observe(contentRef.current);
        }
        return () => {
            resizeObserverRef?.current?.disconnect();
        };
    }, [isActive, updateHeight]);
    return { contentRef, height };
};
export default useResizable;
//# sourceMappingURL=index.js.map